import $ from 'jquery';
import Mustache from 'mustache';
import CSRLabelModel from 'components/csrFactoryMap/models/CSRLabelModel';
import templateCountryList from './templates/countrylist.html';
import EventDispatcher from 'components/csrFactoryMap/utils/EventDispatcher';
import { gsap, Power0, Power2, CSSPlugin } from 'gsap/all';

gsap.registerPlugin(Power0, Power2, CSSPlugin);

export default class CSRDetailCountryView extends EventDispatcher {
  constructor(options) {
    super(options);
    this.el = options.el;
    this.$el = $(this.el);
    this.model = options.model;
    this.isStatic = options.isStatic;

    this.initialize(options.skipAnimation);
  }

  initialize(skipAnimation) {
    this.createTemplate();
    this.cacheSelectors();
    this.transitionIn(skipAnimation);
    this.setupEventListeners();
  }

  destroy(skipAnimation) {
    this.removeEventListeners();
    if (skipAnimation) {
      this.clearContent();
    } else {
      this.transitionOut(() => this.clearContent());
    }
    this.templateCountryList = null;
  }

  createTemplate() {
    // NOTE: Overwrite cities and factories so make distinction between single and plural
    const labelData = CSRLabelModel.getData();
    const correctedLabelData = {
      ...labelData,
      cities: this.model.data.country_cities > 1 ? labelData.cities : labelData.city,
      factories:
        this.model.data.country_factory_count > 1 ? labelData.factories : labelData.factory,
    };

    this.model.data.labels = correctedLabelData;
    this.templateCountryList = Mustache.render(templateCountryList, this.model.data);
    this.renderTemplate(this.templateCountryList, true);
  }

  renderTemplate(template, noAnimation) {
    this.scrollToTop();
    this.clearContent();
    this.el.insertAdjacentHTML('afterbegin', template);
    if (!noAnimation) {
      this.cacheSelectors();
      gsap.fromTo(
        this.ui.detail,
        { duration: 0.4, opacity: 0 },
        { duration: 0.4, opacity: 1, ease: Power0.easeNone }
      );
    }
  }

  transitionOut(callback) {
    gsap.to(this.el, {
      duration: 0.3,
      x: -350,
      ease: Power2.easeInOut,
      clearProps: 'x',
      onComplete: callback,
    });
  }

  transitionIn(skipAnimation) {
    const tl = gsap.timeline();
    if (!skipAnimation) {
      tl.fromTo(this.el, { duration: 0.5, x: -350 }, { x: 0, ease: Power2.easeInOut });
    }
    tl.fromTo(
      this.ui.detail,
      { duration: 0.3, opacity: 0 },
      { opacity: 1 },
      skipAnimation ? 0.2 : 0.55
    );
  }

  scrollToTop() {
    const scroll = { y: window.scrollY };
    gsap.to(scroll, { duration: 0.5, y: 0, onUpdate: () => window.scrollTo(0, scroll.y) });
  }

  clearContent() {
    while (this.el.firstChild) {
      this.el.removeChild(this.el.firstChild);
    }
  }

  cacheSelectors() {
    this.ui = {
      detail: this.el.querySelectorAll('.js-detail')[0],
    };
  }

  setupEventListeners() {
    if (!this.isStatic) {
      this.$el.on('click', '.js-detail-back', this.onBackClicked.bind(this));
      this.$el.on('click', '.js-factory', this.onFactoryClicked.bind(this));
    }
  }

  removeEventListeners() {
    this.$el.off();
  }

  onBackClicked(event) {
    event.preventDefault();

    if (this._detailActive) {
      this._detailActive = false;
      this.renderTemplate(this.templateCountryList);
    } else {
      this.trigger('csrmap:navigate:back');
    }
  }

  onFactoryClicked(e) {
    const id = e.currentTarget.dataset.factoryId;
    this.trigger('csrmap:select:factory', id, false);
  }
}
